import { Chip, type ChipProps, styled } from "@mui/material";
import React from "react";

import { PaymentStatusLabel } from "src/constants";
import { type MediaPaymentStatusEnum } from "src/graphql/generated/types";

interface Props extends ChipProps {
  status: MediaPaymentStatusEnum;
}

const StyledChip = styled(Chip)<{ status: MediaPaymentStatusEnum }>`
  background-color: ${(props) => props.theme.palette.payment.status[props.status]};
  color: ${(props) => props.theme.palette.common.white};
  span {
    font-weight: bold;
  }
`;

export const ChipPaymentStatus = ({ status, ...chipProps }: Props) => {
  return <StyledChip status={status} label={PaymentStatusLabel[status]} {...chipProps} />;
};
